
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import { IUserModel } from '@/models/account.model';
  import { ICookieModel, ISetCookieModel, ICookiesResultModel } from '@/models/cookie.model';

  import errorsService from '@/services/errors.service';
  import accountService from '@/services/account.service';
  import cookieService from '@/services/cookie.service';

  @Component({
    computed: {
      ...mapGetters([
        'user',
        'token'
      ])
    }
  })
  export default class Cookies extends Vue {
    data() {
      return {
        cookiesList: [] as Array<ICookieModel>,
        isLoading: false,
        unwatch: null
      }
    };

    created() {
      this.$data.unwatch = this.$store.watch(() => this.$store.getters.user, user => {
        this.setCookiesList(user);
      })

      if (this.$store.getters.user.Id != null) {
        this.setCookiesList(this.$store.getters.user);
      }
    };

    setCookiesList(user: IUserModel) {
      if (user.Id == null) {
        return;
      }

      this.$data.isLoading = true;
      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "cookie/user/" + user.Id;
      accountService.get<ICookiesResultModel>(this, url, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
        .then(response => {
          this.$data.isLoading = false;
          this.$set(this.$data, "cookiesList", response.Cookies);
          this.$store.dispatch("updateCookies", response.Cookies);

          const consentAnalytics = this.$cookies.get("consent_analytics");
          const isConsentAnalyticsAccepted = consentAnalytics != null && consentAnalytics == "1";
          const consentMarketing = this.$cookies.get("consent_marketing");
          const isConsentMarketingAccepted = consentMarketing != null && consentMarketing == "1";

          let triggerEvent = false;
          response.Cookies.forEach(cookie => {
            if (cookie.Name == "Analytical cookies") {
              cookie.IsAccepted ? cookieService.enableAnalytics(this) : cookieService.disableAnalytics(this);
              triggerEvent = !isConsentAnalyticsAccepted && cookie.IsAccepted ? true : triggerEvent;
            }
            else if (cookie.Name == "Marketing cookies") {
              cookie.IsAccepted ? cookieService.enableAnalytics(this, true) : cookieService.disableAnalytics(this, true);
              triggerEvent = !isConsentMarketingAccepted && cookie.IsAccepted ? true : triggerEvent;
            }
          });

          if (triggerEvent) {
            cookieService.triggerHistoryEvent(this);
          }
        })
        .catch(error => {
          this.$data.isLoading = false;
          errorsService.handleErrors(this, error);
        });
    }

    setCookie(cookie: ICookieModel) {
      this.$data.isLoading = true;

      const user = this.$store.getters.user;
      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "cookie/user/" + user.Id + "/set-cookie";

      accountService.post<ISetCookieModel, object>(this, url, { Id_Cookie: cookie.Id, IsAccepted: !cookie.IsAccepted }, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
        .then(() => {
          this.$data.isLoading = false;

          let triggerEvent = false;
          if (cookie.Name == "Analytical cookies") {
            cookie.IsAccepted ? cookieService.enableAnalytics(this) : cookieService.disableAnalytics(this);
            triggerEvent = cookie.IsAccepted ? true : false;
          }
          else if (cookie.Name == "Marketing cookies") {
            cookie.IsAccepted ? cookieService.enableAnalytics(this, true) : cookieService.disableAnalytics(this, true);
            triggerEvent = cookie.IsAccepted ? true : false;
          }

          if (triggerEvent) {
            cookieService.triggerHistoryEvent(this);
          }
        })
        .catch(error => {
          this.$data.isLoading = false;
          errorsService.handleErrors(this, error);
        });
    }

    destroyed() {
      this.$data.unwatch();
    }
  }
